import React from "react";
import { motion } from "framer-motion";
import { useM } from "../useM";

const line = (i) => ({
  initial: { opacity: 0, y: 60 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.9, delay: 0.25 + i * 0.12, ease: [0.22, 1, 0.36, 1] },
});

export const Hero = () => {
  const m = useM();
  return (
    <section className="relative h-[100svh] min-h-[640px] w-full overflow-hidden bg-mk-bg" data-testid="hero-section">
      <video className="absolute inset-0 h-full w-full object-cover" poster="/media/hero-poster.jpg?v=2"
        autoPlay muted loop playsInline preload="auto" aria-hidden="true" data-testid="hero-video">
        <source src="/media/hero.webm?v=2" type="video/webm" />
        <source src="/media/hero.mp4?v=2" type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-r from-mk-bg via-mk-bg/70 to-mk-bg/10" />
      <div className="absolute inset-0 bg-gradient-to-t from-mk-bg via-transparent to-mk-bg/50" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_10%_90%,hsl(var(--brand-blue)/0.35),transparent_55%)]" />
      <div className="mk-grain absolute inset-0" />
      <div className="relative z-10 mx-auto flex h-full max-w-7xl flex-col justify-center px-6 pb-12 pt-28 lg:px-10">
        <h1 className="font-heading text-5xl font-black uppercase leading-[0.88] tracking-tight text-white sm:text-7xl lg:text-[6.5rem] [@media(max-height:760px)]:lg:text-7xl" data-testid="hero-title">
          {["hero.title1", "hero.title2", "hero.title3"].map((k, i) => (
            <span key={k} className="block overflow-hidden pb-1">
              <motion.span {...line(i + 1)} className={`block ${i === 2 ? "text-mk-yellow" : ""}`}>{m(k)}</motion.span>
            </span>
          ))}
        </h1>
        <motion.p {...line(4)} className="mt-8 max-w-xl text-base leading-relaxed text-white/75 md:text-lg" data-testid="hero-subtitle">{m("hero.sub")}</motion.p>
      </div>
      <div className="absolute bottom-8 right-6 z-10 hidden flex-col items-center gap-3 lg:right-10 md:flex">
        <span className="font-mono-t text-[10px] uppercase tracking-[0.3em] text-white/40 [writing-mode:vertical-rl]">{m("hero.scroll")}</span>
        <span className="mk-scroll-line h-14 w-px bg-white/15" />
      </div>
    </section>
  );
};
